/*
* wehsoft Theme
*
* Use this file to add custom Javascript to wehsoft.  Keeping your custom
* Javascript in this fill will make it easier to update wehsoft. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  function initProgressiveDiscountBar() {
    const settings = window.progressiveDiscountBarSettings;
    if (!settings || !settings.blocks || settings.blocks.length === 0) {
      return;
    }

    function formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.', ''); }
      let value = '';
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let formatString = format || settings.money_format;

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        let parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands),
          cents_str = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents_str;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) return cents;

      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    function updateBar(cartTotal) {
      const bars = document.querySelectorAll('[data-progressive-discount-bar]');

      bars.forEach((container) => {
        const messageEl = container.querySelector('[data-message]');
        const fillEl = container.querySelector('[data-progress-fill]');
        const markers = container.querySelectorAll('.pdb__marker');

        if (!messageEl || !fillEl) return;

        const sortedBlocks = [...settings.blocks].sort((a, b) => a.threshold - b.threshold);
        if (sortedBlocks.length === 0) return;

        const maxThreshold = sortedBlocks[sortedBlocks.length - 1].threshold;

        let nextLevel = null;

        for (let i = 0; i < sortedBlocks.length; i++) {
          const block = sortedBlocks[i];
          if (cartTotal < block.threshold) {
            if (!nextLevel) nextLevel = block;
          }
        }

        // Calculate fill percentage
        const fillPercent = Math.min(100, (cartTotal / maxThreshold) * 100);
        fillEl.style.width = fillPercent + '%';

        // Build message
        let message = '';
        if (nextLevel) {
          const remaining = nextLevel.threshold - cartTotal;
          const remainingFormatted = formatMoney(remaining);

          message = nextLevel.message_next
            .replace('[amount]', '<strong>' + remainingFormatted + '</strong>')
            .replace('[reward]', '<strong>' + nextLevel.reward_name + '</strong>');
        } else {
          message = settings.final_message;
        }
        messageEl.innerHTML = message;

        // Update markers
        markers.forEach((marker) => {
          const markerThreshold = parseInt(marker.dataset.threshold);
          if (cartTotal >= markerThreshold) {
            marker.classList.add('is-reached');
          } else {
            marker.classList.remove('is-reached');
          }
        });
      });
    }

    let debounceTimer = null;
    function fetchCartAndUpdate() {
      // Debounce to avoid multiple rapid calls
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateBar(cart.total_price);
          })
          .catch(() => { });
      }, 100);
    }

    // Initial update
    fetchCartAndUpdate();

    // Listen for theme cart events (bubbling from anywhere in the document)
    document.addEventListener('theme:cart:update', fetchCartAndUpdate, true);
    document.addEventListener('theme:cart:add', fetchCartAndUpdate, true);
    document.addEventListener('theme:cart:loaded', fetchCartAndUpdate, true);
    document.addEventListener('theme:cart:change', fetchCartAndUpdate, true);
    document.addEventListener('theme:drawer:open', fetchCartAndUpdate, true);

    // Listen for quantity input changes directly
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-quantity-field], .quantity__input, input[name="updates[]"]')) {
        fetchCartAndUpdate();
      }
    }, true);

    // Listen for click on quantity buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-quantity-button], .quantity__button, .js-qty__adjust')) {
        // Delay slightly to let the cart update complete
        setTimeout(fetchCartAndUpdate, 300);
      }
    }, true);

    // MutationObserver for dynamic DOM updates (cart drawer content)
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if ((node.matches && node.matches('[data-progressive-discount-bar]')) ||
                (node.querySelector && node.querySelector('[data-progressive-discount-bar]'))) {
                shouldUpdate = true;
              }
              // Also check if cart content was updated
              if (node.matches && (node.matches('[data-cart-drawer]') || node.matches('.cart-drawer__items'))) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      if (shouldUpdate) {
        fetchCartAndUpdate();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Intercept fetch calls to /cart endpoints
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const result = originalFetch.apply(this, args);

      if (args[0] && typeof args[0] === 'string') {
        const url = args[0];
        if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add')) {
          result.then(() => {
            setTimeout(fetchCartAndUpdate, 200);
          }).catch(() => { });
        }
      }

      return result;
    };
  }

  /*
   * Collection bundle promotions: blocks the "Finalizar compra" submit when
   * the shopper has items from a configured promo collection but hasn't yet
   * reached that collection's minimum quantity. Product-to-collection
   * mapping and thresholds come from window.collectionBundlePromoSettings
   * (rendered in layout/theme.liquid from the "Collection Bundle Promotions"
   * theme settings). The actual promotional price must be configured as an
   * automatic discount in Shopify admin — this only gates checkout and
   * informs the shopper.
   */
  function initCollectionBundlePromo() {
    const settings = window.collectionBundlePromoSettings;
    if (!settings || !settings.promos || settings.promos.length === 0) {
      return;
    }

    let modalEl = null;

    function buildModal() {
      if (modalEl) return modalEl;

      const overlay = document.createElement('div');
      overlay.setAttribute('data-cbp-modal-overlay', '');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;';

      const box = document.createElement('div');
      box.style.cssText = 'background:#fff;color:#000;max-width:420px;width:100%;padding:28px 24px;border-radius:4px;position:relative;';

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Fechar');
      closeBtn.textContent = '×';
      closeBtn.style.cssText = 'position:absolute;top:8px;right:12px;background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:inherit;';
      closeBtn.addEventListener('click', hideModal);

      const title = document.createElement('h3');
      title.setAttribute('data-cbp-title', '');
      title.style.cssText = 'margin:0 0 10px;font-size:18px;';

      const intro = document.createElement('p');
      intro.setAttribute('data-cbp-intro', '');
      intro.style.cssText = 'margin:0 0 14px;font-size:14px;opacity:.8;';

      const list = document.createElement('ul');
      list.setAttribute('data-cbp-list', '');
      list.style.cssText = 'margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:8px;';

      box.appendChild(closeBtn);
      box.appendChild(title);
      box.appendChild(intro);
      box.appendChild(list);
      overlay.appendChild(box);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) hideModal();
      });
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') hideModal();
      });

      document.body.appendChild(overlay);
      modalEl = overlay;
      return overlay;
    }

    function hideModal() {
      if (modalEl) modalEl.style.display = 'none';
    }

    function showModal(unmetPromos) {
      const overlay = buildModal();
      overlay.querySelector('[data-cbp-title]').textContent = settings.modal_title || 'Falta pouco!';

      const introEl = overlay.querySelector('[data-cbp-intro]');
      if (settings.modal_intro) {
        introEl.textContent = settings.modal_intro;
        introEl.style.display = '';
      } else {
        introEl.style.display = 'none';
      }

      const list = overlay.querySelector('[data-cbp-list]');
      list.innerHTML = '';
      unmetPromos.forEach(function (promo) {
        const remaining = promo.min_qty - promo.count;
        const li = document.createElement('li');
        li.style.cssText = 'padding:10px 12px;background:#f6f6f6;border-radius:4px;font-size:13px;';
        let text = 'Faltam ' + remaining + (remaining > 1 ? ' peças' : ' peça') + ' da coleção "' + promo.title + '"';
        if (promo.price_label) text += ' — ' + promo.price_label;
        li.textContent = text;
        list.appendChild(li);
      });

      overlay.style.display = 'flex';
    }

    /*
     * The product IDs of each collection are fetched here, at runtime, instead
     * of being rendered by Liquid: collection.products stops at 50 items (a hard
     * platform limit that "offset" does not get around), so any product past the
     * 50th was never counted and the shopper had to add extra pieces to unlock
     * checkout. products.json pages 250 at a time, so it covers the whole
     * collection. Results are cached per page load.
     */
    const PRODUCTS_PER_PAGE = 250;
    const MAX_PAGES = 20;
    const idsByHandle = {};

    function fetchCollectionIds(handle) {
      if (idsByHandle[handle]) return idsByHandle[handle];

      const ids = new Set();

      function fetchPage(page) {
        const url = '/collections/' + encodeURIComponent(handle) +
          '/products.json?limit=' + PRODUCTS_PER_PAGE + '&page=' + page;

        return fetch(url, { cache: 'no-store' })
          .then(function (r) {
            if (!r.ok) throw new Error('products.json responded ' + r.status);
            return r.json();
          })
          .then(function (data) {
            const products = (data && data.products) || [];
            products.forEach(function (p) { ids.add(p.id); });

            if (products.length === PRODUCTS_PER_PAGE && page < MAX_PAGES) {
              return fetchPage(page + 1);
            }
            return ids;
          });
      }

      idsByHandle[handle] = fetchPage(1).catch(function (err) {
        delete idsByHandle[handle]; // lets the next attempt retry instead of reusing a failure
        throw err;
      });

      return idsByHandle[handle];
    }

    function loadPromosWithIds() {
      return Promise.all(settings.promos.map(function (promo) {
        return fetchCollectionIds(promo.handle).then(function (ids) {
          return Object.assign({}, promo, { product_ids: ids });
        });
      }));
    }

    function getPromoCounts(cart, promos) {
      return promos.map(function (promo) {
        let count = 0;
        cart.items.forEach(function (item) {
          if (promo.product_ids.has(item.product_id)) count += item.quantity;
        });
        return Object.assign({}, promo, { count: count });
      });
    }

    // Only blocks a promo the shopper has actually started (count > 0) but
    // not yet completed. A collection with zero items in cart is simply not
    // part of that shopper's purchase and should not block checkout.
    function getUnmetPromos(cart, promos) {
      return getPromoCounts(cart, promos).filter(function (promo) {
        return promo.count > 0 && promo.count < promo.min_qty;
      });
    }

    // Warms the cache so clicking "Finalizar compra" doesn't wait on the network.
    settings.promos.forEach(function (promo) {
      fetchCollectionIds(promo.handle).catch(function () {});
    });

    // Intercepts the click on the checkout button itself (not the form
    // submit) so that, once validated, we can re-dispatch a real click on
    // the *same* button and let the browser submit natively. Calling
    // form.submit() programmatically does NOT include the clicked button's
    // name/value in the POST body, so Shopify's /cart endpoint has no way
    // to know "checkout" was pressed and redirects back to /cart instead of
    // /checkout — re-clicking the button is what preserves that.
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('button[name="checkout"]');
      if (!btn || !btn.closest('[data-cart-form]')) return;

      if (btn.__cbpBypass) {
        btn.__cbpBypass = false;
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      Promise.all([
        fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }),
        loadPromosWithIds()
      ])
        .then(function (results) {
          const unmet = getUnmetPromos(results[0], results[1]);
          if (unmet.length === 0) {
            btn.__cbpBypass = true;
            btn.click();
          } else {
            showModal(unmet);
          }
        })
        .catch(function () {
          // Fails open: never trap the shopper if our own check breaks.
          btn.__cbpBypass = true;
          btn.click();
        });
    }, true);
  }

  /*
   * Fix: third-party apps add to cart via a direct POST to /cart/add(.js) and
   * then open the cart drawer, but they never trigger the theme's getCart()
   * refresh. The drawer ends up showing stale content. Here we intercept any
   * /cart/add request (fetch or XHR) and force the theme to re-fetch and
   * rebuild the drawer (window.cart.getCart) before it is shown.
   */
  function initCartDrawerRefresh() {
    // When the theme handles a cart operation natively it already calls
    // getCart(), so we skip our refresh briefly to avoid a redundant
    // double-rebuild / flicker.
    let themeHandledUntil = 0;
    ['theme:cart:add', 'theme:cart:update', 'theme:cart:change'].forEach((ev) => {
      document.addEventListener(ev, () => {
        themeHandledUntil = Date.now() + 1200;
      }, true);
    });

    let refreshTimer = null;
    function refreshCartDrawer() {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        if (Date.now() < themeHandledUntil) return; // theme is already refreshing
        const cart = window.cart;
        if (cart && typeof cart.getCart === 'function' && cart.cartDrawer) {
          cart.getCart();
        }
      }, 200);
    }

    function getUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input === 'object') return input.url || input.href || '';
      return '';
    }

    // Third-party apps (e.g. free-gift apps) mutate the cart through these
    // endpoints; the theme's own add also hits /cart/add (guarded above).
    function isCartMutationUrl(url) {
      if (typeof url !== 'string') return false;
      return url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1;
    }

    // Intercept fetch
    const originalFetch = window.fetch;
    window.fetch = function (...fetchArgs) {
      const result = originalFetch.apply(this, fetchArgs);
      if (isCartMutationUrl(getUrl(fetchArgs[0]))) {
        result.then(() => refreshCartDrawer()).catch(() => { });
      }
      return result;
    };

    // Intercept XMLHttpRequest (many apps use XHR or jQuery.ajax)
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__isCartMutation = isCartMutationUrl(getUrl(url));
      return originalOpen.apply(this, [method, url, ...rest]);
    };
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (...sendArgs) {
      if (this.__isCartMutation) {
        this.addEventListener('load', () => refreshCartDrawer());
      }
      return originalSend.apply(this, sendArgs);
    };

    // Catch-all: whenever the drawer is (re)opened — including when a gift app
    // closes and reopens it after the shopper picks a gift — pull fresh content.
    // This also covers gifts injected server-side (Shopify Functions / cart
    // transforms) that never trigger a client-side cart request.
    const drawer = document.querySelector('[data-cart-drawer]');
    function isDrawerOpen() {
      return document.body.classList.contains('js-drawer-open-cart') ||
        (drawer && drawer.classList.contains('is-open'));
    }
    let wasOpen = isDrawerOpen();
    function onDrawerClassChange() {
      const open = isDrawerOpen();
      if (open && !wasOpen) {
        // A reopen after a gift selection is exactly the case the native theme
        // flow does not handle. (Native first-open is skipped by the guard.)
        refreshCartDrawer();
      }
      wasOpen = open;
    }
    const openObserver = new MutationObserver(onDrawerClassChange);
    openObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (drawer) {
      openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Cupom de desconto na PDP: copia o código ao clicar e mostra "copiado"
  // somente quando a escrita na área de transferência realmente aconteceu.
  // Delegado no document para funcionar também no quickview e em seções
  // re-renderizadas pelo editor de tema.
  function initCouponCopy() {
    const COPIED_CLASS = 'is-copied';
    const FEEDBACK_MS = 2000;

    function legacyCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(textarea);
      return ok;
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(
          () => true,
          () => legacyCopy(text)
        );
      }
      return Promise.resolve(legacyCopy(text));
    }

    // Produto com preço de comparação (em promoção) não acumula cupom:
    // esconde o bloco quando a variante selecionada está em oferta.
    document.addEventListener('theme:variant:change', (event) => {
      const container = event.target;
      if (!container || !container.querySelectorAll) return;

      const variant = event.detail && event.detail.variant;
      const onSale = !!variant && variant.compare_at_price > variant.price;

      container.querySelectorAll('[data-coupon-box]').forEach((box) => {
        box.classList.toggle('hidden', onSale);
      });
    });

    document.addEventListener('click', (event) => {
      const box = event.target.closest('[data-coupon-box]');
      if (!box) return;

      const code = (box.dataset.couponCode || '').trim();
      if (!code) return;

      copyText(code).then((ok) => {
        if (!ok) return;

        box.classList.add(COPIED_CLASS);
        clearTimeout(box.__couponTimer);
        box.__couponTimer = setTimeout(() => {
          box.classList.remove(COPIED_CLASS);
        }, FEEDBACK_MS);
      });
    });
  }

  // Run init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProgressiveDiscountBar);
    document.addEventListener('DOMContentLoaded', initCollectionBundlePromo);
  } else {
    initProgressiveDiscountBar();
    initCollectionBundlePromo();
  }

  // Drawer de filtros (coleção/busca): fecha ao clicar fora ou apertar Esc.
  // Usa o botão [data-close-filters] do próprio drawer para que o tema
  // remova a trava de scroll e o focus trap corretamente.
  function initFiltersDrawerClose() {
    function closeVisibleDrawer() {
      const drawer = document.querySelector('.collection__filters--visible');
      if (!drawer) return false;
      const closeBtn = drawer.querySelector('[data-close-filters]');
      if (!closeBtn) return false;
      closeBtn.click();
      return true;
    }

    document.addEventListener('click', function (e) {
      const drawer = document.querySelector('.collection__filters--visible');
      if (!drawer) return;
      // composedPath preserva o caminho mesmo se o tema re-renderizar o alvo.
      const path = e.composedPath ? e.composedPath() : [];
      const clickedInside = path.some(function (el) {
        return el === drawer || (el.matches && el.matches('[data-toggle-filters]'));
      });
      if (!clickedInside) closeVisibleDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeVisibleDrawer();
    });
  }

  // Cart drawer refresh must run regardless of the discount bar being present.
  initCartDrawerRefresh();
  initCouponCopy();
  initFiltersDrawerClose();
})();
